import { editor } from 'monaco-editor'

export const darkTheme: editor.IStandaloneThemeData = {
    base: 'vs-dark',
    inherit: true,
    colors: {
        'editor.background': '#27303F',
        'editorCursor.foreground': '#ECC94D',
        'editor.lineHighlightBackground': '#2F394B',
        'editorLineNumber.foreground': '#505C72',
        'editorLineNumber.activeForeground': '#505C72',
        'editor.selectionBackground': '#505C72',
    },
    rules: [
        { token: 'comment', foreground: '#C8EA92' },
        { token: 'string', foreground: '#C2ADFF' },
        { token: 'delimiter.comma', foreground: '#9BE1FF' },
        { token: 'type', foreground: '#F18585' },
    ],
}

export const monacoOptions: editor.IStandaloneEditorConstructionOptions = {
    minimap: {
        enabled: false,
    },
    wordWrap: 'wordWrapColumn',
    wordWrapColumn: 50,
    fontSize: 14,
}
